import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-package",
  "use": "icon-package-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-package\"><defs><style type=\"text/css\"></style></defs><path d=\"M464 256H64l48.672-146.048A67.2 67.2 0 0 1 176.448 64H480zM960 256H560L544 64h303.552a67.2 67.2 0 0 1 63.744 45.952zM64 320v572.8A67.2 67.2 0 0 0 131.2 960h761.6a67.2 67.2 0 0 0 67.2-67.2V320z m384 512H192v-64h256z\" fill=\"\" p-id=\"8375\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol